import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.regexp.flags.js";
import "core-js/modules/es.array.includes.js";
import { Dialog, Flex, Markdown, Text } from '@applyboard/crystal-ui';
import { StopwatchHifiIcon } from '@applyboard/ui-icons';
import { useTranslation } from '@applyboard/ui-utils';
import { useMemo } from 'react';
import { useApplication, useApplicationRequirements } from "../../data";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export function HurryUpDialog(_ref) {
  var requirementId = _ref.requirementId,
    isOpen = _ref.isOpen,
    onOpenChange = _ref.onOpenChange;
  var _useTranslation = useTranslation('RequirementList'),
    t = _useTranslation.t;
  var _useApplication = useApplication(),
    application = _useApplication.application;
  var _useApplicationRequir = useApplicationRequirements(),
    applicationRequirements = _useApplicationRequir.applicationRequirements;
  var requirement = applicationRequirements.find(function (_ref2) {
    var id = _ref2.id;
    return id === requirementId;
  });
  var numRequirementsNeedAction = useMemo(function () {
    var filteredRequirements = applicationRequirements.filter(function (_ref3) {
      var status = _ref3.status,
        classification = _ref3.classification,
        flags = _ref3.flags,
        applicationStage = _ref3.applicationStage;
      return ['missing', 'rejected'].includes(status) && classification === 'applicant_requirement' && applicationStage === (requirement === null || requirement === void 0 ? void 0 : requirement.applicationStage) && !flags.optional;
    });
    return filteredRequirements.length;
  }, [applicationRequirements, requirement]);
  var shouldOpen = useMemo(function () {
    return numRequirementsNeedAction > 0 && !!application.instantSubmissionEnabled && (!(requirement !== null && requirement !== void 0 && requirement.applicationStage) || ['pre-submission', 'pre-payment'].includes(requirement.applicationStage));
  }, [application, numRequirementsNeedAction, requirement]);
  return _jsxs(Dialog, {
    open: isOpen && shouldOpen,
    onOpenChange: onOpenChange,
    children: [_jsx(Dialog.Heading, {
      children: t('hurryUpDialog.title')
    }), _jsx(Dialog.Content, {
      children: _jsxs(Flex, {
        gap: 6,
        align: "start",
        children: [_jsx(StopwatchHifiIcon, {
          intent: "secondary",
          contrast: "mid"
        }), _jsxs(Flex, {
          direction: "column",
          gap: 4,
          children: [_jsx(Markdown, {
            markdown: t('hurryUpDialog.info', {
              count: numRequirementsNeedAction
            }),
            headingSettings: {
              baseLevel: 2
            }
          }), _jsx(Text, {
            children: t('hurryUpDialog.infoContinued')
          })]
        })]
      })
    }), _jsx(Dialog.Actions, {
      children: _jsx(Flex, {
        direction: "column",
        grow: 1,
        children: _jsx(Flex.Item, {
          align: "end",
          children: _jsx(Dialog.CloseButton, {
            emphasis: "contained",
            intent: "primary",
            width: "hug",
            children: t('hurryUpDialog.ok')
          })
        })
      })
    })]
  });
}